export default __webpack_public_path__ + "static/spiritual-christian-shrines-2-482589dc8e3e6c4649eb9ff73781831b.jpg";